// extracted by mini-css-extract-plugin
module.exports = {"dsTableRow":"_1Fjosq7aC5bRLBCf6LWWWI","selectorCheckbox":"lcpvk0clN8jwtAv7wRsYZ","dsTableParent":"_3rUUGiTeEGFxWoNMvtkYVl"};